import { handleFilaAprovadores } from "./Pedido";
import { NormalFont } from "./styles";

function handleNumeroBMSI(item, DisparaBootBox, FechaBootBox, navigate){
    const { PZ2_ID, EMPRESA, PZ2_FILIAL } = item.row.original;

    return ( <>
                {<NormalFont tooltipText={"Fila de Aprovadores"} onClick={(e)=> handleFilaAprovadores("BM','BC','BD", PZ2_ID, EMPRESA, PZ2_FILIAL, DisparaBootBox, FechaBootBox)}><strong>Fil.: </strong>{PZ2_FILIAL}</NormalFont>}
                <br/><NormalFont><strong>BMSI: {item.value} </strong></NormalFont>                
            </> )
}

function handleTipoBMSI(item){
    const { PZ2_SERVIC, PZ2_CCCRED, PZ2_CONTAD, PZ1_DESCRI, CTT_DESC01, CT1_DESC01 } = item.row.original
    return (
            <>
                <p><strong>{PZ2_SERVIC} - </strong> {PZ1_DESCRI}</p>
                <p><strong>CC: </strong>{PZ2_CCCRED} - {CTT_DESC01}</p>
                <p><strong>Conta: </strong>{PZ2_CONTAD} - {CT1_DESC01}</p>
            </>
    )
}

function handleStatusBMSI(item){
    const { REPROVADO, PENDENTE, APROVADO, CONTABIL } = item.row.original
    const status = (REPROVADO > 0 && APROVADO == 0 && PENDENTE == 0 ? 'Reprovado' : 
                        REPROVADO > 0 && (APROVADO > 0 || PENDENTE > 0) ? 'Iten(s) Reprovado' :
                            APROVADO > 0 && PENDENTE == 0 ? 
                                CONTABIL > 0 ? APROVADO > CONTABIL ? 'Parcialmente Contabilizado' : 'Contabilizado' 
                                             : 'Aprovado' : 'Aguardando Aprovação' )
    
    return (                        
            <>
                <p>{status}</p>
            </>
    )
}

export { handleNumeroBMSI, handleTipoBMSI, handleStatusBMSI }